import { createIcon } from '@chakra-ui/icon';
import * as React from 'react';
export var InfoIcon = createIcon({
  displayName: 'InfoIcon',
  viewBox: '0 0 14 24',
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "12",
    fill: "none",
    r: "6.5",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("mask", {
    fill: "white",
    id: "path-2-inside-info"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8 8H6V10H8V8ZM8 11H6V16H8V11Z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6 8V7H5V8H6ZM8 8H9V7H8V8ZM6 10H5V11H6V10ZM8 10V11H9V10H8ZM6 11V10H5V11H6ZM8 11H9V10H8V11ZM6 16H5V17H6V16ZM8 16V17H9V16H8ZM6 9H8V7H6V9ZM7 10V8H5V10H7ZM8 9H6V11H8V9ZM7 8V10H9V8H7ZM6 12H8V10H6V12ZM7 16V11H5V16H7ZM8 15H6V17H8V15ZM7 11V16H9V11H7Z",
    fill: "currentColor",
    mask: "url(#path-2-inside-info)"
  }))
});
//# sourceMappingURL=Info.js.map